<button type="button" class="filter-btn">
  <i class="iconlace iconlace-filter-mixer"></i>
  Filtrar
</button>
